<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="owners">
      @for (owner of owners.controls; track owner; let index = $index) {
        <ng-container [formGroup]="owner">
          <div class="row">
            <div class="col-md-12">
              <owner-header [owners]="owners" [index]="index"></owner-header>
              <phones formArrayName="contactPhones" [derrors]="derrors">
              </phones>
            </div>
          </div>
        </ng-container>
      }
    </ng-container>
  </form-wrapper>

  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>

  <div class="pr-form-submit action action-default flex-row"></div>
</form>
